module.exports = __webpack_public_path__ + "img/icon-price.2cd525b2.svg";